import { render, staticRenderFns } from "./CommonStatementDocument.vue?vue&type=template&id=e2fb9ec2&scoped=true"
import script from "./CommonStatementDocument.vue?vue&type=script&lang=js"
export * from "./CommonStatementDocument.vue?vue&type=script&lang=js"
import style0 from "./CommonStatementDocument.vue?vue&type=style&index=0&id=e2fb9ec2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2fb9ec2",
  null
  
)

export default component.exports